import { type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';

const Home = (): unknown => {
    return import(/* webpackPrefetch: true */ './home-page.vue');
};

export const homeRoute: RouteRecordRaw = {
    ...ROUTE_DATA.HOME_PAGE,
    components: {
        main: Home
    }
};
